import { render, staticRenderFns } from "./TravelCostInfo.vue?vue&type=template&id=179b8e18&scoped=true&"
import script from "./TravelCostInfo.vue?vue&type=script&lang=js&"
export * from "./TravelCostInfo.vue?vue&type=script&lang=js&"
import style0 from "./TravelCostInfo.vue?vue&type=style&index=0&id=179b8e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b8e18",
  null
  
)

export default component.exports